
(ns manage.studio-preview.db
  (:require [re-frame.core :as rf]))

(rf/reg-event-fx :studio-preview/init
  [(rf/inject-cofx :sub :context)]
  (fn [{:keys [db context]}]
    {:db (-> db
             (assoc :studio-preview context)
             (assoc-in [:studio-preview :state] :pending))
     :dispatch [:resource.adset/post-preview-token]
     :forward-events [{:register :studio-preview/preview-token
                       :events #{:resource.adset/post-preview-token-success}
                       :dispatch-to [:studio-preview/preview-token-success]}
                      {:register :studio-preview/preview-token-fail
                       :events #{:resource.adset/post-preview-token-failure}
                       :dispatch-to [:studio-preview/preview-token-failure]}]}))

(rf/reg-event-fx :studio-preview/destroy
  (fn []
    {:fx [[:forward-events [{:unregister :studio-preview/preview-token}
                            {:unregister :studio-preview/preview-token-fail}]]]}))

(rf/reg-event-fx :studio-preview/preview-token-success
  (fn [{:keys [db]} [_ [_ {:keys [token]}]]]
    (let [studio-preview (:studio-preview db)
          template-id (:template-id studio-preview)
          height (:height studio-preview)
          width (:width studio-preview)
          stage (:stage studio-preview)]
      {:router/navigate! [:common/shared-rules-preview
                          {:params {:preview-token token}
                           :query {:template-id template-id
                                   :width width
                                   :height height
                                   :stage stage}}]})))

(rf/reg-event-db :studio-preview/preview-token-failure
  (fn [db]
    (assoc-in db [:studio-preview :state] :failure)))

(rf/reg-sub :studio-preview/state
  (fn [db]
    (get-in db [:studio-preview :state])))
